import type { ReactNode } from 'react';

interface PageContainerProps {
  children: ReactNode;
}

/**
 * Page container that provides consistent padding and spacing.
 * Accounts for fixed header and bottom navigation.
 */
export function PageContainer({ children }: PageContainerProps) {
  return (
    <main className="px-4 py-4 pb-8">
      {children}
    </main>
  );
}
